import { useGetAllResourcesQuery, useGetAllResourceTypesQuery } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSeasonSlice } from '../../slice';
import { selectIsSeasonsLoaded } from '../../slice/selectors';

interface IProps {
  children: React.ReactChild;
}

const SeasonWrapper = (props: IProps) => {
  const isSeasonsLoaded = useSelector(selectIsSeasonsLoaded);
  const envId = useSelector(selectSelectedEnvId) as number;
  const dispatch = useDispatch();
  const { actions } = useSeasonSlice();

  const { isLoading: isResourceTypesLoading } = useGetAllResourceTypesQuery();
  const { isLoading: isResourcesLoading } = useGetAllResourcesQuery({ envId });

  useEffect(() => {
    if (envId) {
      dispatch(actions.getSeasons(envId));
    }
  }, [dispatch, actions, envId]);

  if (!isSeasonsLoaded || isResourceTypesLoading || isResourcesLoading) {
    return null;
  }

  return <> {props.children} </>;
};

export default SeasonWrapper;
